import axios from "@/axios.js";
import constants from "@/constants.js";
export default {
  async getCoachUserData({ commit }, userId) {
    try {
      const resObj = await axios.get(
        `${constants.coachIntegrationServiceUrl}/user/quest/${userId}`
      );
      commit("SET_COACH_DATA", resObj.data.data);
      return resObj.data.data;
    } catch (error) {
      throw error;
    }
  },
};
